/*
 * Open the header mega menu on hover / on keyboard focus.
 * Toggles the native <details> "open" state so every existing Dawn open style,
 * animation and a11y handler applies unchanged. Click and keyboard still work.
 * The desktop check is evaluated per event (and stays live on resize); below
 * 990px Dawn hides the inline menu and uses the drawer, so this is inert there.
 * Loaded as an asset (not inline) so it passes the storefront CSP.
 */
(function () {
  function init() {
    var mq = window.matchMedia('(min-width: 990px)');

    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
      if (menu.dataset.hoverBound === 'true') return;
      var details = menu.querySelector('details.mega-menu');
      if (!details) return;
      menu.dataset.hoverBound = 'true';

      var summary = details.querySelector('summary');
      var closeTimer;
      var hovering = false;

      function open() {
        clearTimeout(closeTimer);
        if (details.hasAttribute('open')) return;
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }

      function close() {
        clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) return;
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }

      menu.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        hovering = true;
        open();
      });

      menu.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        hovering = false;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(close, 150);
      });

      if (summary) {
        summary.addEventListener('click', function (event) {
          // Only swallow the toggle when hover already opened it via a real
          // pointer click on desktop. Keyboard (detail === 0) and touch taps
          // fall through to the native <details> behaviour.
          if (mq.matches && hovering && event.detail !== 0) event.preventDefault();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
